module.exports = __webpack_public_path__ + "img/infinity.99bd15f9.svg";